"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProps = void 0;
const react_1 = __importStar(require("react"));
const GridColumn_1 = require("../GridColumn");
const helpers_1 = require("../../helpers");
const checkboxCellRenderer_1 = require("../cellRenderers/checkboxCellRenderer");
const headerCheckboxCellRenderer_1 = require("../cellRenderers/headerCheckboxCellRenderer");
const createProps = (width, index, id, columnId) => {
    const newProps = {
        key: columnId || `grid-${id}-column-${index}`
    };
    if (width) {
        Object.assign(newProps, {
            width: parseInt(String(width), 10)
        });
    }
    return newProps;
};
exports.createProps = createProps;
const columnsAdapter = ({ columnsList, children, selection, id, toggleable }) => {
    const gridColumns = columnsList
        ? columnsList.map((col) => (0, react_1.createElement)(GridColumn_1.GridColumn, col))
        : children;
    react_1.Children.toArray(gridColumns)
        .filter((col) => react_1.default.isValidElement(col) && (col === null || col === void 0 ? void 0 : col.props.columnId))
        .map((col) => react_1.default.isValidElement(col) && (col === null || col === void 0 ? void 0 : col.props.columnId))
        .forEach((id, index, self) => {
        const entries = self.filter((selfId) => selfId === id).length;
        if (entries > 1) {
            throw new Error(`GridColumn ID must be unique, but "${id}" have been used ${entries} times`);
        }
    });
    const normalizedColumns = react_1.Children.toArray(gridColumns).map((column, index) => (0, react_1.cloneElement)(column, (0, exports.createProps)(column.props.width, index, id, column.props.columnId)));
    if (selection === null || selection === void 0 ? void 0 : selection.checkbox) {
        normalizedColumns.unshift((0, react_1.createElement)(GridColumn_1.GridColumn, {
            field: '',
            isSelectionColumn: true,
            key: `grid-${id}-selection`,
            width: 36,
            cell: checkboxCellRenderer_1.checkboxCellRenderer,
            headerCell: headerCheckboxCellRenderer_1.headerCheckboxCellRenderer
        }));
    }
    if (toggleable) {
        normalizedColumns.push((0, react_1.createElement)(GridColumn_1.GridColumn, {
            field: '',
            isToggleColumn: true,
            key: `grid-${id}-toggle`,
            width: helpers_1.GRID_TOGGLE_BUTTON_WIDTH
        }));
    }
    return normalizedColumns;
};
exports.default = columnsAdapter;
//# sourceMappingURL=columnsAdapter.js.map